import { render, staticRenderFns } from "./BasicFieldsListHandler.vue?vue&type=template&id=7bc9f0d6"
import script from "./BasicFieldsListHandler.vue?vue&type=script&lang=js"
export * from "./BasicFieldsListHandler.vue?vue&type=script&lang=js"
import style0 from "./BasicFieldsListHandler.vue?vue&type=style&index=0&id=7bc9f0d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports